<template>
  <div class="dialog-content">
    <div class="dialog-c-title">
      {{ title }}
      <i id="add-to-cart-close" class="material-icons" @click="closeModal"
        >clear</i
      >
    </div>
    <div class="dialog-c-text">
      <div class="dialog-c-text__img_wrap">
        <div class="dialog-c-text__img_wrap__image">
          <img
            :data-src="getProductImageUrl"
            class="cld-responsive"
            :alt="getProductImageAlt"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          />
        </div>
      </div>
      <div class="dialog-c-text__data">
        <div class="dialog-c-text__data__title">
          {{ this.getProductTitleDetails }}
        </div>
        <div class="dialog-c-text__data__sku">{{ getProductSkuCode }}</div>
        <ProductBrandLogos class="dialog-c-text__data__brand_logos" />
        <div v-if="showSinglePrice" class="dialog-c-text__data__singlePrice">  
        {{ singlePrice }}
        </div>
        <div class="dialog-c-text__data__price">
          <span v-if="showCurrencySymbol">{{ getCurrencySymbol }}</span>{{ getProductPriceText }}
        </div>
      </div>
      <div class="break"></div>
      <div class="dialog-c-text__buttons">
        <div class="dialog-buttons" v-if="buttons">
          <button
            v-for="(button, i) in buttons"
            :class="'dialog-button btn ' + (button.class || 'btn-default')"
            type="button"
            :key="i"
            v-html="button.title"
            @click.stop="click(i, $event)"
            :id="button.title.replace(/ /gi, '-')"
          >
            {{ button.title }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductBrandLogos from "./../ProductBrandLogos";
import cloudinary from "cloudinary-core";
import { legacyIsQuote } from "../../../legacy";

export default {
  data() {
  return {
    showSinglePrice: false,
    showCurrencySymbol: false,
    singlePrice: "",
  }
},
  computed: {
    ...mapGetters("product", [
      "getProductSku",
      "getProductTitle",
      "getImage",
      "getCurrencyCode",
      "getProductFormattedPrice",
      "getProductPrice",
      "getCurrencySymbol",
    ]),
    ...mapGetters("user", ["getIsUserLimited"]),
    ...mapGetters("addToCartCount", [
      "getIncrementLabel",
      "getValidCartCount",
      "getMinimumOrderUnitOfMeasure"
      ]),
    isQuote() {
      return legacyIsQuote() || this.getIsUserLimited;
    },
    getProductPriceText() {      
      if (this.source && this.source === "triggeredfromcompatibleproduct") {
        this.hidePriceViews();
        return this.pricetext;
      } else {
        const cartCountSelected = this.getValidCartCount;
        this.showPriceViews(cartCountSelected);
        const optionalPdpIncrementLable = this.getMinimumOrderUnitOfMeasure 
        ? ` / ${this.getMinimumOrderUnitOfMeasure}`
         : `${this.getCurrencyCode}`;
        const singlePrice = `${this.getProductFormattedPrice} ${optionalPdpIncrementLable}`;
        this.updateSinglePrice(singlePrice);
        const totalPrice = parseFloat(this.getProductPrice.RawPrice * cartCountSelected).toFixed(2);
        return totalPrice;
      }
    }, 
    getProductSkuCode() {
      if (this.source && this.source === "triggeredfromcompatibleproduct") {
        return "SKU: " + this.skucode;
      } else {
        const sku = this.getProductSku;
        return sku ? "SKU: " + sku.SkuCode : "";
      }
    },
    getProductTitleDetails() {
      if (this.source && this.source === "triggeredfromcompatibleproduct") {
        return this.producttitle;
      } else {
        return this.getProductTitle;
      }
    },
    getProductImageUrl() {
      if (this.source && this.source === "triggeredfromcompatibleproduct") {
        return this.productimage;
      } else {
        return this.getImage[0].Url;
      }
    },
    getProductImageAlt() {
      if (this.source && this.source === "triggeredfromcompatibleproduct") {
        return this.productimagealt;
      } else {
        return this.getImage[0].Url;
      }
    },
  },
  props: {
    source: {
      type: String
    },
    skucode: {
      type: String
    },
    producttitle: {
      type: String
    },
    productimage: {
      type: String
    },
    productimagealt: {
      type: String
    },
    pricetext: {
      type: String
    },
    title: {
      type: String
    },
    quantity: {
      type: Number
    },
    buttons: {
      type: Array
    }
  },
  methods: {
    click(i, event, source = "click") {
      const button = this.buttons[i];
      if (button && typeof button.handler === "function") {
        button.handler({
          i,
          event,
          source,
          parentName: this.$parent.$parent.name
        });
      } else {
        this.$modal.hide(this.$parent.$parent.name);
      }
    },
    closeModal() {
      this.$modal.hide(this.$parent.$parent.name);
    },
    showPriceViews(cartCountSelected) {
      if (cartCountSelected > 1){
        this.showCurrencySymbol = true;
        this.showSinglePrice = true;
      } else {
        this.showCurrencySymbol = true;
        this.showSinglePrice = false;
      }
      
    },
    hidePriceViews() {
      this.showCurrencySymbol = false;
      this.showSinglePrice = false;
    },
    updateSinglePrice(singlePrice) {
      this.singlePrice = singlePrice;
    },
  },
  mounted() {
    const cloudinaryCore = new cloudinary.Cloudinary({
      cloud_name: "demo"
    });
    cloudinaryCore.responsive();
  },
  
  components: {
    ProductBrandLogos
  }
};
</script>

<style lang="scss">
.dialog-content {
  border: 1px solid $gray-light;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
  color: $gray-dark;
  font-size: 16px;
  background-color: $white;
  .dialog-c-title {
    font-family: $font-family-sans-serif-medium;
    font-size: 24px;
    letter-spacing: $letter-spacing-xs;
    color: #233c3f;
    padding: 13px 20px 7px 30px;
    background-color: $gray-light;
    min-height: 60px;
    display: flex;
    @include media-breakpoint-up(sm) {
      font-size: 28px;
      padding-top: 10px;
    }
    i {
      margin-top: 15px;
      margin-left: auto;
      font-size: 30px;
      cursor: pointer;
      @include media-breakpoint-up(sm) {
        font-size: 36px;
        margin-top: 18px;
      }
    }
  }
  .dialog-c-text {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 30px;
    @include media-breakpoint-up(sm) {
      flex-direction: row;
    }
    @include media-breakpoint-up(md) {
      flex-wrap: nowrap;
    }
    @include media-breakpoint-up(lg) {
    }
    /* Inserting this collapsed row between two flex items will make 
    * the flex item that comes after it break to a new row */
    .break {
      @include media-breakpoint-up(sm) {
        height: 0;
        flex-basis: 100%;
      }
      @include media-breakpoint-up(md) {
        display: none;
      }
    }
    &__img_wrap {
      margin-bottom: 15px;
      width: 100%;
      @include media-breakpoint-up(sm) {
        width: 33%;
      }
      @include media-breakpoint-up(md) {
        width: 176px;
      }
      &__image {
        width: 50%;
        margin: auto;
        @include media-breakpoint-up(sm) {
          width: initial;
        }
        @include media-breakpoint-up(md) {
        }
        img {
          border: 1px solid rgb(204, 204, 204);
          width: 100%;
          background: rgb(204, 204, 204)
            url("https://res.cloudinary.com/avd/image/upload/v1575988321/placeholder-image.svg")
            no-repeat;
          background-position: center;
          background-size: 25%;
        }
      }
    }
    &__data {
      color: $gray-darker;
      font-family: $font-family-sans-serif-regular;
      @include media-breakpoint-up(sm) {
        padding-right: 0;
        padding-left: 20px;
        width: 66%;
      }
      @include media-breakpoint-up(md) {
        padding-right: 20px;
        width: 60%;
      }
      &__title {
        font-family: $font-family-sans-serif-medium;
        font-size: 20px;
        padding-bottom: 10px;
      }
      &__sku {
        color: $gray-dark;
        font-size: 16px;
        padding-bottom: 3px;
      }
      &__brand_logos {
        padding-bottom: 10px;
        @include media-breakpoint-up(sm) {
          padding-bottom: 16px;
        }
      }
      &__price {
        font-family: $font-family-sans-serif-medium;
        font-size: 18px !important;        
        padding-bottom: 20px;
        color:#333333 !important;
        font-weight: 500 !important;
        letter-spacing: 0.25px;
        @include media-breakpoint-up(lg) {
          padding-bottom: 0;
        }
      }
      &__singlePrice {
        font-size: 14px !important;
        color: #666766 !important;
        padding-bottom: 3px;       
        letter-spacing: 0.25px;
        
      }
    }
    &__buttons {
      width: 100%;
      @include media-breakpoint-up(md) {
        width: 192px;
      }
      .dialog-buttons {
        text-align: right;
        .dialog-button {
          width: 100%;
          font-weight: 600;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>